import { Grid } from 'react-styled-flexboxgrid'
import styled from 'styled-components'

export const StyledGrid = styled(Grid)<{ withSidebar?: boolean }>`
  padding: 0;
  padding-right: ${({ theme }) => theme.space.lg};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-right: 0;
  }
`

export const ContentBox = styled.div<{ hasNotif?: boolean }>`
  margin-top: ${({ theme, hasNotif }) => (hasNotif ? theme.space.lg : theme.space.xxl)};
`

export const MenuTabBox = styled.div`
  width: 100%;
  min-width: max-content;
`

export const Inline = styled.div`
  display: flex;

  .badge {
    margin-left: ${({ theme }) => theme.space.xs};
  }
`
